import * as React from 'react';

export interface IHiddenCommonProps {
	acceptanceTestTargetId: string;
	formControlId?: string;
	name: string;
}

export interface IHiddenPrimitiveProps {
	value: string;
	name: string;
}

export type IHiddenProps = IHiddenPrimitiveProps & IHiddenCommonProps;

export class HiddenInput extends React.Component<IHiddenProps, {}> {
	input: HTMLInputElement;

	render() {
		let type = 'hidden';
		const {
			value,
			formControlId,
			acceptanceTestTargetId = null,
			...rest } = this.props;

		return (
			<input
				{...rest}
				value={value}
				type={type}
				spellCheck={false}
				id={formControlId}
				data-pp-at-target={acceptanceTestTargetId}
				name={name}
			/>
		);
	}
}

